import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

// Moves one tech node to a grid cell. Dispatched once, on pointer-up, never
// per pointer-move: executeCommand snapshots the whole model as a JSON string
// per call, so a command per move event would mean hundreds of whole-model
// serializations and a per-pixel undo stack for one drag.
//
// Returns false when the node is already on that cell, so a click without a
// move adds no history entry at all (see integrator.context executeCommand).
export class SetTechNodePositionCommand extends CommandBase {
    id: string;
    x: number;
    y: number;

    constructor(id: string, x: number, y: number) {
        super();
        this.id = id;
        this.x = x;
        this.y = y;
    }

    execute(data: RemoteConstantsModel): boolean {
        const node = data.techTree.find(t => t.id === this.id);
        if (node === undefined) {
            return false;
        }

        if (node.x === this.x && node.y === this.y) {
            return false;
        }

        node.x = this.x;
        node.y = this.y;
        return true;
    }
}
